// extracted by mini-css-extract-plugin
module.exports = {"aboutLine":"About_aboutLine__jeXX9"};